/**
 * Machine Registry
 *
 * Domain: Workflow > Engine
 * Description: Registry of all workflow machine configs and guards.
 * Spec: Documentation/Specification/04_Processes/application-agnostic/workflow/00_StateMachineFramework.md
 */
import { onboardingConfig } from './configs/onboarding.js';
import { terminationConfig } from './configs/termination.js';
import { disciplinaryWarningConfig } from './configs/disciplinary-warning.js';
import { pipConfig } from './configs/pip.js';
import { notificationDispatchConfig } from './configs/notification-dispatch.js';
import { invoiceConfig } from './configs/invoice.js';
import { contractAlertConfig } from './configs/contract-alert.js';
import { tutoringSessionConfig } from './configs/tutoring-session.js';
import { tutoringAgreementConfig } from './configs/tutoring-agreement.js';
import { tutoringScheduleConfig } from './configs/tutoring-schedule.js';
import { tutorConfig } from './configs/tutor.js';
import { studentConfig } from './configs/student.js';
import { clientConfig } from './configs/client.js';
import { serviceAuthorisationConfig } from './configs/service-authorisation.js';
import { serviceOrderConfig } from './configs/service-order.js';
import * as onboardingGuards from './guards/onboarding.js';
import * as terminationGuards from './guards/termination.js';
import * as disciplinaryWarningGuards from './guards/disciplinary-warning.js';
import * as pipGuards from './guards/pip.js';
import * as notificationDispatchGuards from './guards/notification-dispatch.js';
import * as invoiceGuards from './guards/invoice.js';
import * as contractAlertGuards from './guards/contract-alert.js';
import * as tutoringSessionGuards from './guards/tutoring-session.js';
import * as tutoringAgreementGuards from './guards/tutoring-agreement.js';
import * as tutoringScheduleGuards from './guards/tutoring-schedule.js';
import * as tutorGuards from './guards/tutor.js';
import * as studentGuards from './guards/student.js';
import * as clientGuards from './guards/client.js';
import * as serviceAuthorisationGuards from './guards/service-authorisation.js';
import * as serviceOrderGuards from './guards/service-order.js';
export const machineRegistry = {
    onboarding: {
        config: onboardingConfig,
        guards: onboardingGuards,
    },
    termination: {
        config: terminationConfig,
        guards: terminationGuards,
    },
    'disciplinarywarning': {
        config: disciplinaryWarningConfig,
        guards: disciplinaryWarningGuards,
    },
    'disciplinary-warning': {
        config: disciplinaryWarningConfig,
        guards: disciplinaryWarningGuards,
    },
    pip: {
        config: pipConfig,
        guards: pipGuards,
    },
    'notification-dispatch': {
        config: notificationDispatchConfig,
        guards: notificationDispatchGuards,
    },
    invoice: {
        config: invoiceConfig,
        guards: invoiceGuards,
    },
    'contract-alert': {
        config: contractAlertConfig,
        guards: contractAlertGuards,
    },
    'tutoring-session': {
        config: tutoringSessionConfig,
        guards: tutoringSessionGuards,
    },
    'tutoring-agreement': {
        config: tutoringAgreementConfig,
        guards: tutoringAgreementGuards,
    },
    'tutoring-schedule': {
        config: tutoringScheduleConfig,
        guards: tutoringScheduleGuards,
    },
    tutor: {
        config: tutorConfig,
        guards: tutorGuards,
    },
    student: {
        config: studentConfig,
        guards: studentGuards,
    },
    client: {
        config: clientConfig,
        guards: clientGuards,
    },
    'service-authorisation': {
        config: serviceAuthorisationConfig,
        guards: serviceAuthorisationGuards,
    },
    'service-order': {
        config: serviceOrderConfig,
        guards: serviceOrderGuards,
    },
};
//# sourceMappingURL=registry.js.map